export enum BreakPointClass {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl'
}

export enum Theme {
  LightPurple = 'light-purple',
  White = 'white',
  Yellow = 'yellow'
}

